// extracted by mini-css-extract-plugin
export default {"headAdminPage":"adminpage_headAdminPage__BhkZa","first":"adminpage_first__SPPAR","send":"adminpage_send__HUitz"};